import legalData from '../data/legal-sources.json' with { type: 'json' };
const data = legalData;
const sourceByKey = new Map(data.legalSources.filter((s) => s.verified).map((s) => [s.key, s]));
/** Mapping FederalState → LBO-Quellen-Key in legalSources. */
const STATE_LBO_KEY = {
    BW: 'lbo-bw',
    BY: 'baybo',
    BE: 'bauo-bln',
    BB: 'bbgbo',
    HB: 'bremlbo',
    HH: 'hbauo',
    HE: 'hbo',
    MV: 'lbauo-mv',
    NI: 'nbauo',
    NW: 'bauo-nrw',
    RP: 'lbauo-rp',
    SL: 'lbo-sl',
    SN: 'saechsbo',
    ST: 'bauo-lsa',
    SH: 'lbo-sh',
    TH: 'thuerbo',
};
export function getLegalSources() {
    return Array.from(sourceByKey.values());
}
export function getLegalSource(key) {
    return sourceByKey.get(key);
}
/**
 * Liefert die Rechtsquellen, die für ein Feld relevant sind.
 *
 * Wenn `state` übergeben wird, wird die landesspezifische LBO bevorzugt
 * gegenüber der generischen MBO. Beispiel: für Feld `buildingClass` und
 * `state='NW'` kommt zuerst `BauO NRW`, dann `MBO`.
 */
export function getLegalSourcesForField(fieldKey, state) {
    const keys = [...(data.fieldMappings[fieldKey] ?? [])];
    // Generische MBO durch landes-LBO ersetzen, wenn passend.
    if (state && keys.includes('mbo')) {
        const stateKey = STATE_LBO_KEY[state];
        if (stateKey) {
            keys.splice(keys.indexOf('mbo'), 1, stateKey);
        }
    }
    return keys.map((k) => sourceByKey.get(k)).filter((s) => s != null);
}
/**
 * Liefert die für ein Bundesland geltende Landesbauordnung.
 */
export function getLboSource(state) {
    if (!state)
        return sourceByKey.get('mbo');
    return sourceByKey.get(STATE_LBO_KEY[state]);
}
/**
 * Alle Quellen mit einem bestimmten Geltungsbereich (z. B. alle Bayern-Quellen).
 */
export function getLegalSourcesByScope(scope) {
    return Array.from(sourceByKey.values()).filter((s) => s.scope === scope);
}
export const legalLastVerified = data.lastVerified;
export const legalVersion = data.version;
